export default __webpack_public_path__ + "static/media/autoit.f16091a4.svg";